import {Component, ElementRef, OnInit} from '@angular/core';
import {Contact} from "../../../../models/contact.model";
import {ContactService} from "../../../../services/contact.service";
import Swal from "sweetalert2";
import {Router} from "@angular/router";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss']
})
export class MailComponent implements OnInit {

  concatInfos: Contact [] = [];
  initialConcatInfos: Contact [] = [];
  contactInfo!: Contact;
  replyMessage: boolean = false;

  search: any;

  page: number = 1;
  size: number = 10;

  constructor(private contactInfoService: ContactService,
              private elementRef: ElementRef,
              private router: Router,
              private fb: FormBuilder,
              private datePipe: DatePipe) {
  }

  ngOnInit(): void {
    this.all();
  }

  formDate = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  contactInfoForm = this.fb.group({
    message: new FormControl('', [Validators.required, Validators.minLength(12)])
  })

  get message(){
    return this.contactInfoForm.get('message');
  }

  all() {
    this.contactInfoService.allContact().subscribe(data => {
      this.concatInfos = data;
      this.initialConcatInfos = this.concatInfos;
    })
  }

  displayReplyMessage() {
    this.replyMessage = true;

    if(this.replyMessage){
      const replySection = this.elementRef.nativeElement.querySelector("#replySection");
      if (replySection) {
        replySection.scrollIntoView({behavior: 'smooth'});
      }
    }
  }

  hideReplyMessage() {
    this.replyMessage = false;
  }

  getContactInfo(id: number) {
    this.contactInfoService.getidContact(id).subscribe(data => {
      this.contactInfo = data;
      //console.log(this.contactInfo);
    }, error => {
    //  console.log(error);
    })
  }

  delete(id: number) {
    Swal.fire({
      title: 'Voulez-vous vraiment ce mail ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.contactInfoService.deleteContact(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Mail supprimé avec succès',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
           // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur lors de la suppression du mail',
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  sendReplyMessage() {
    if(this.contactInfoForm.invalid){
      this.contactInfoForm.markAllAsTouched();
      return;
    }
    const message = this.contactInfoForm.get(['message']).value;

    this.contactInfoService.replyMessage(this.contactInfo.id, message).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Reponse envoyé avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.replyMessage = false;
      this.contactInfoForm.reset();
      this.all();
    }, error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de l\'envoie de la réponse',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  searchUserByEmail($event: KeyboardEvent) {
    this.contactInfoService.allContact().subscribe(data => {
      this.concatInfos = data;
      this.concatInfos = this.concatInfos.filter(value =>
        value?.email?.includes(this.search.trim())
      )
    }, error => {
      //console.log(error);
    })
  }

  raiseSizeOfTable(event: any) {
    this.size = event.target.value;
  }

  begin: any
  displayErrorMessage: boolean = false;
  disabledEndDate: boolean = true;
  getBeginDate(event: any) {
    this.begin = event.target.value;
    if(this.begin){
      this.disabledEndDate = false;
      if(this.begin > this.end){
        this.displayErrorMessage = true;
      }else{
        this.displayErrorMessage = false;
      }
    }else{
      this.disabledEndDate = true;
    }
  }

  end: any;
  getEndDate(event: any) {
    this.end = event.target.value;
    if(this.begin > this.end){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  filterByDate() {
    const begin = this.formDate.get('beginDate').value;
    const end = this.formDate.get('endDate').value;

    if(begin == '' || end == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let transformEndDate: any = new Date(end);
    transformEndDate.setDate(transformEndDate.getDate() + 1);
    transformEndDate = this.datePipe.transform(transformEndDate, 'yyyy-MM-dd')

    // console.log(begin);
    // console.log(transformEndDate);

    this.concatInfos = this.initialConcatInfos.filter(c => {
      return (c.createdAt >= begin) && (c.createdAt <= transformEndDate);
    })
  }


  refreshFilter() {
    this.formDate = this.fb.group({
      beginDate: new FormControl(''),
      endDate: new FormControl('')
    })
    this.all();
  }

  ascendingOrder: boolean = true;
  sortByName() {
    this.concatInfos.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if(this.ascendingOrder){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrder = !this.ascendingOrder;
  }

  ascendingOrderEmail: boolean = true;
  sortByEmail() {
    this.concatInfos.sort((a, b) => {
      const emailA = a.email.toLowerCase();
      const emailB = b.email.toLowerCase();

      if(this.ascendingOrderEmail){
        return emailA.localeCompare(emailB);
      }else {
        return emailB.localeCompare(emailA);
      }
    })
    this.ascendingOrderEmail = !this.ascendingOrderEmail;
  }

  ascendingOrderMessage: boolean = true;
  sortByMessage() {
    this.concatInfos.sort((a, b) => {
      const messageA = a.message.toLowerCase();
      const messageB = b.message.toLowerCase();

      if(this.ascendingOrderMessage){
        return messageA.localeCompare(messageB);
      }else {
        return messageB.localeCompare(messageA);
      }
    })
    this.ascendingOrderMessage = !this.ascendingOrderMessage;
  }

  ascendingOrderDate: boolean = true;
  sortByDate() {
    this.concatInfos.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if(this.ascendingOrderDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderDate = !this.ascendingOrderDate;
  }

  filterByStatus(event: any) {
    let value = event.target.value;
    this.concatInfos = this.initialConcatInfos.filter(result => {
      if(value == 'all'){
        this.all();
      }else{
        return String(result.replied).includes(value);
      }
    })
  }
}
